<div class="add-medicine">
  <div class="add-medicine__header">
    <div class="add-medicine__title-row">
      <div class="add-medicine__icon" aria-hidden="true">
        <mat-icon>medication</mat-icon>
      </div>
      <div>
        <h2 class="add-medicine__title">Add medicines</h2>
        <p class="add-medicine__subtitle">
          Search for a medicine, choose dosage and package type, then add it to this prescription.
        </p>
      </div>
    </div>
  </div>

  <form [formGroup]="addMedicineForm" class="add-medicine__form">
    <div class="add-medicine__fields row g-2">
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="add-medicine__field add-medicine__field--search" subscriptSizing="dynamic">
          <mat-icon matPrefix>search</mat-icon>
          <input
            required
            [disabled]="isLoading"
            data-testid="add-medicine-name"
            type="text"
            placeholder="Search for medicine"
            aria-label="Search for medicine"
            matInput
            formControlName="medicineFilter"
            [matAutocomplete]="auto" />
          <mat-autocomplete
            data-testid="add-medicine-autocompletion-list"
            panelClass="add-medicine-autocomplete-panel"
            (optionSelected)="medicineSelected($event)"
            autoActiveFirstOption
            #auto="matAutocomplete">
            @for (med of medicine; track med) {
              <mat-option [value]="med">{{ med.name }}</mat-option>
            }
          </mat-autocomplete>
          @if (addMedicineForm.get('medicineFilter')?.invalid) {
            <mat-error>Medicine is invalid</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-form-field appearance="outline" class="add-medicine__field" subscriptSizing="dynamic">
          <mat-label>Dosage type</mat-label>
          <mat-select
            required
            data-testid="add-medicine-dosage-type"
            [disabled]="isLoading || dosageTypes.length === 0"
            formControlName="dosageType"
            (selectionChange)="getMedicineDosagePackageTypes($event)">
            @for (type of dosageTypes; track type) {
              <mat-option [value]="type">
                {{ type.additional_information }}
              </mat-option>
            }
          </mat-select>
          @if (addMedicineForm.get('dosageType')?.invalid) {
            <mat-error>Dosage type is invalid</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-form-field appearance="outline" class="add-medicine__field" subscriptSizing="dynamic">
          <mat-label>Package type</mat-label>
          <mat-select
            (selectionChange)="packageTypeSelected($event)"
            required
            data-testid="add-medicine-package-type"
            formControlName="packageType">
            @for (type of medicineDosageTypePackageTypes; track type) {
              <mat-option [value]="type">
                {{ type.package_type.type }} ({{ type.contained_quantity }})
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-form-field appearance="outline" class="add-medicine__field add-medicine__field--quantity">
          <mat-label>Quantity</mat-label>
          <input
            required
            data-testid="add-medicine-quantity"
            autocomplete="off"
            type="number"
            min="1"
            formControlName="quantity"
            matInput />
          @if (addMedicineForm.get('quantity')?.invalid) {
            <mat-error>Quantity is invalid</mat-error>
          }
          @if (selectedMedicineDosagePackageType) {
            <mat-hint>
              <span class="add-medicine__units-available">
                {{ selectedMedicineDosagePackageType.stock_on_hand }} units available
              </span>
            </mat-hint>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="add-medicine__actions">
      <button
        [disabled]="addMedicineForm.invalid || isLoading || !selectedDosageType"
        data-testid="add-medicine-add-button"
        type="button"
        (click)="addOrderItem()"
        mat-flat-button
        color="primary"
        class="add-medicine__submit">
        <mat-icon>add</mat-icon> Add medicine
      </button>
    </div>
  </form>
</div>
